import React from "react";
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles'; 
import "./style/newsLetter.css";
import axios from 'axios';
import { Grid, Row, Col } from "react-flexbox-grid";
import InputAdornment from '@material-ui/core/InputAdornment';
import sendnewsletter from "../assets/Newsletter/sendnewsletter.svg"



const styles = theme => ({
    textField: {
        width: "100%",
    }
});

class NewsLetter extends React.Component {
    constructor(props) {
        super(props);
    
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    
        this.state = {
          Email: ''
        };
      }    

      onChangeEmail(e) {
        this.setState({
          Email: e.target.value
        })
      }
    
      onSubmit(e) {
        e.preventDefault();
    
        const subscriber = {
            email: this.state.Email
        }

        axios.post(`${process.env.REACT_APP_SERVER}`+'/subscribe', subscriber)
          .then(res => {
            window.location = '/';})
          .catch((error) => {
            console.log(error);
          })
    
      }
    

    render() {
        const { classes } = this.props;
        return (
            <Grid fluid className="newsLetterBack">
                <Row style={{ marginRight: "auto", marginLeft: "auto", wordWrap: "break-word", maxWidth: "1200px"}}>
                    <Col xs={12} md={6} lg={6} style={{maxWidth: "95%" , textAlign: "center", marginLeft:"auto" , marginRight:"auto"}}>
                        <h2 className="titleNews">Inscrivez-vous à notre Newsletter </h2>
                    </Col>
                    <Col xs={12} md={6} lg={6} style={{maxWidth: "85%" , textAlign: "center", marginLeft:"auto" , marginRight:"auto"}}>
                    <form onSubmit={this.onSubmit} style={{position:"relative"}}>
                        <TextField
                            id="standard-dense"
                            label="Adresse mail:"
                            className={classNames(classes.textField)}
                            value={this.state.Email}
                            onChange={this.onChangeEmail}
                            color = 'secondary'
                            size="small"
                        />
                        <button  type="submit" style={{position: "absolute", bottom:"5px", right: "40px", backgroundColor:"#ffd32a"}}><img src={sendnewsletter} alt=""/></button>
                        </form>
                    </Col>
                    
                </Row>
               
            </Grid>
        );
    }
}

NewsLetter.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NewsLetter);


// WEBPACK FOOTER //
// ./src/home/newsLetter.js